// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: 'https://467af7f8712f7dadc80b1d9c18092058@o1430821.ingest.us.sentry.io/4509453075808256',
  environment: process.env.NEXT_PUBLIC_VERCEL_ENV || 'development',
  // Disable sending events when running locally or in non-production environments
  enabled: process.env.NODE_ENV === 'production',

  // Prevent any events originating from a localhost URL from being sent to Sentry
  beforeSend(event) {
    if (
      event.request?.url?.includes('localhost') ||
      (typeof window !== 'undefined' && window.location.hostname === 'localhost')
    ) {
      return null;
    }
    return event;
  },
  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false

  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});
